export const LOGIN = '/login';
export const MARKET_ROUTE = '/market';
export const ADMIN_USER_MANAGEMENT = '/admin';
